<template>
<div class="game row position-relative">
    <div class="display-settings position-absolute top-0 end-0 translate-middle-y w-auto z-1">
        <div class="mr-5 mr-md-4 pt-2 fs-5 d-inline-block align-middle">
            <div class="status-switch position-relative" :class="'status-'+item.status">
                <div class="background-bar"></div>
                <div class="form-check form-check-inline mb-0 mr-0 ml-0">
                  <input v-tooltip="{ content: 'Vizibil', trigger: 'hover click'}" class="form-check-input cursor-pointer status-available" type="radio" value="available" v-model="item.status">
                </div>
                <div class="form-check form-check-inline mb-0 mr-0 ml-3">
                  <input v-tooltip="{ content: 'Rezervat', trigger: 'hover click'}" class="form-check-input cursor-pointer status-reserved" type="radio" value="reserved" v-model="item.status">
                </div>
                <div class="form-check form-check-inline mb-0 mr-n3 ml-3 pr-1">
                  <input v-tooltip="{ content: 'Ascuns', trigger: 'hover click'}" class="form-check-input cursor-pointer status-hidden" type="radio" value="hidden" v-model="item.status">
                </div>
            </div>
        </div>
        <div class="badge ml-n4 ml-md-0 d-inline-block align-middle mr-2 mr-md-n3">
              <popper trigger="clickToOpen" :options="{ placement: 'left-end', modifiers: {} }">
                <div class="popper bg-danger text-white p-3">
                  <div>Ești sigur? Jocul va trebui manual readăugat<br/> sau importat și setările refăcute.</div>
                  <div class="mx-auto d-inline-block mt-2" role="button" v-on:click="deleteGame(index)"><i class="text-white fa-solid fa-square-check fs-3"></i></div>
                </div>
                <div role="button" slot="reference" class="badge rounded-pill fs-6 bg-danger">
                    <i class="text-white fa-solid fa-trash-can"></i>
                </div>
              </popper>
        </div>
    </div>
    <div class="col-12 mb-4" :class="{ 'opacity-25': item.status=='hidden' || item.status=='reserved' }">
        <div class="card shadow h-100 p-0 p-md-2 position-relative" :class="'border-left-'+item.condition+' border-right-'+checkDiscount(item)+' '+(sort_mode?'cursor-move':'')">
            <template v-if="item.status!='hidden' && !sort_mode && !price_history[item.id]">
                <div class="card-body pt-2 pb-0" :class="{'pb-2': ['other','bundle'].includes(item.type)}">
                    <div class="row align-items-center h-100">
                        <div v-if="(!item.thumbnail && !item.no_thumbnail) || is_thumbnail_uploading" class="cover cursor-pointer col-1 mr-2 h-100 text-center d-mobile-none">
                            <div v-if="item.type=='bundle'"><div :class="'text-'+item.condition"><i class="fa-solid fa-box fs-4rem mt-2"></i></div></div>
                            <template v-else>
                                <div v-if="item.type!='other' || is_thumbnail_uploading" class="spinner-grow text-success mt-2" role="status"></div>
                                <div v-else @click="selectThumbnail(item.id)"><div :class="'text-'+item.condition"><i class="fa-solid fa-file-arrow-up fs-4rem mt-2"></i></div></div>
                            </template>
                        </div>
                        <div v-else class="cover col-1 mr-2 h-100 d-mobile-none" :style="{ backgroundImage: 'url(\''+item.thumbnail+'\')' }"></div>
                        <div class="col pl-0 pl-md-2 ml-md-1">
                            <div class="cover min-height-80px bg-md-none pl-5 pl-md-1 ml-n1 ml-md-0" :style="{ backgroundImage: 'linear-gradient(to right, transparent 0%, transparent 6%, #FFFFFF 15%, #ffffff 60%, transparent 100%), url(\''+item.thumbnail+'\')' }">
                                <div class="row no-gutters">
                                    <div class="col-4 mr-2">
                                        <div class="text-xs font-weight-bold text-uppercase mb-1 d-inline" :class="'text-'+item.condition">
                                            <select v-model="item.condition" @input="updateCondition($event)" class="status-select">
                                              <option value="new">Nou (În țiplă)</option>
                                              <option value="likenew">Ca nou</option>
                                              <option value="verygood">Stare foarte bună</option>
                                              <option value="good">Stare bună</option>
                                              <option value="acceptable">Folosit</option>
                                            </select>
                                        </div>
                                        <span v-if="typeof item.versions != 'undefined' && item.versions.length > 2" class="position-relative" v-tooltip="{ content: 'Alege varianta pentru copertă', trigger: 'hover click'}">
                                            <div class="position-absolute w-100 text-xs font-weight-bold text-uppercase mb-1 d-inline opacity-0">
                                                <select v-model="item.thumbnail" class="cursor-pointer">
                                                  <option v-for="(version, i) in item.versions" :value="version.thumbnail">{{version.name}}{{version.year ? ' - '+version.year:''}}</option>
                                                </select>
                                            </div>
                                            <span :class="'align-middle text-'+item.condition">
                                                <i class="cursor-pointer pl-2 fa-solid fa-code-branch"></i>
                                            </span>
                                        </span>
                                    </div>
                                    <div v-if="item.type!='other'" class="col text-right">
                                        <template v-if="item.type!='bundle'">
                                            <span v-if="loading_price_history[item.id]" class="loading-inline mr-1"></span>
                                            <span v-else @click="showPriceHistory(item.id)" class="cursor-pointer mr-1 align-middle"><span><i class="fa-solid fa-chart-line"></i></span></span>
                                            <a v-if="item.shop" :href="'https://howtoplay.ro/oferte-boardgames/bgg-'+item.id" target="_blank" class="text-xs mb-1" :class="{ 'text-muted': !item.shop.stock }" data-toggle="tooltip" data-placement="top" :title="item.shop.name">
                                                <b v-if="item.shop.stock">NOU</b> 
                                                <span v-else>În trecut</span>
                                                de la <b>{{ item.shop.price }} RON</b> <span class="d-mobile-none ml-1">la <b>{{ item.shop.name }}</b></span> <span :class="'text-'+item.condition"><i class="ml-1 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
                                            </a>
                                            <span v-else class="text-xs mb-1 text-muted">Nu există în magazine</span>
                                        </template>
                                        <template v-else>
                                            <span v-if="bundle_shop().stock" class="text-xs mb-1" v-tooltip="{ content: checkException(item)?'Conține jocuri indisponibile în magazine':'', trigger: 'hover click'}">
                                                <b>NOU</b> de la 
                                                <b>{{ bundle_shop().price }} RON</b> 
                                                <span v-if="bundle_shop().exception">*</span>
                                            </span>
                                            <span v-else class="text-xs mb-1 text-muted">Nu există în magazine</span>
                                        </template>
                                    </div>
                                </div>
                                <div class="row no-gutters mb-1">
                                    <div class="col mr-2">
                                        <a :href="game_link" v-if="item.type!='other' && item.type!='bundle'" @click.prevent="clickGame(item)" class="name h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white">
                                            {{ item.name }} 
                                            <span :class="'text-'+item.condition">
                                                <i class="h6 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i>
                                            </span>
                                        </a>
                                        <template v-else>
                                            <span v-if="item.type=='other'" @click="selectThumbnail(item.id)" class="h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white cursor-pointer">
                                                {{ item.name }} 
                                                <span :class="'text-'+item.condition">
                                                    <i class="h6 fa-solid fa-file-arrow-up"></i>
                                                </span>
                                            </span>
                                            <span v-else class="h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white">
                                                {{ item.name }} 
                                            </span>
                                        </template>

                                        <div v-if="!['other','bundle'].includes(item.type)" class="shadow-white stats text-xs text-md-s">
                                            <span :class="'text-'+item.condition"><i class="fa-solid fa-star"></i></span> <strong>{{ item.rating }}</strong>
                                            <span :class="'text-'+item.condition"><i class="fa-solid fa-users ml-2"></i></span> {{ item.minplayers }}{{ (parseInt(item.maxplayers) > parseInt(item.minplayers)) ? " - "+item.maxplayers : "" }}
                                            <span :class="'text-'+item.condition"><i class="fa-solid fa-clock ml-2"></i></span> {{ item.minplaytime }}'{{ (parseInt(item.maxplaytime) > parseInt(item.minplaytime)) ? " - "+item.maxplaytime+"'" : "" }}
                                            <span :class="'text-'+item.condition"><i class="fa-solid fa-weight-hanging ml-2"></i></span> {{ item.weight }}
                                        </div>
                                        <div v-else class="input-group mb-0 text-gray align-left pr-2 d-block">
                                            <div class="float-start">
                                                <span class="text-xs text-md-s font-weight-bold mr-1">Descriere:</span>
                                            </div>
                                            <span class="d-block overflow-hidden">
                                                <input v-model="item.notes" type="text" class="border-0 text-xs text-md-s w-100" :placeholder="item.type=='other'?'avarii, piese lipsă, dimensiuni, etc.':'alte informații despre pachet'">
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-3 text-right">
                                        <div class="input-group h5 mb-0 font-weight-bold text-gray-800 align-middle">
                                            <input @input="updatePrice($event, index)" type="number" class="form-control bg-light border rounded-0 small" placeholder="RON" :value="item.price">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters ml-0 ml-md-n2">
                                <div class="col-9">
                                    <div v-show="item.bgg_data" class="description">
                                        <p class="mechanics collapse mb-1 text-xs" :id="'collapse'+item.id" aria-expanded="false">
                                            <span v-for="mechanic in item.mechanics" class="mechanic d-inline-block pl-1 pr-1 mr-1 mb-1 text-white" :class="'background-'+item.condition">{{ mechanic }}</span>
                                        </p>
                                        <p v-html="item.description" class="collapse m-0 hide" :id="'collapse'+item.id" aria-expanded="false"></p>
                                        <a role="button" class="collapsed text-s align-top" :class="'text-'+item.condition" data-bs-toggle="collapse" :href="'#collapse'+item.id" aria-expanded="false" aria-controls="collapse"></a>  
                                    </div>
                                </div>
                                <div class="col-3 text-right" :class="{'min-height-50px': getDiscount(item)}">
                                    <h3 v-if="getDiscount(item)" class="text-white mr-n2 mr-md-n3 rounded-top-left text-right d-inline" :class="discount_label_class" v-tooltip="{ content: checkException(item)?'Conține jocuri indisponibile în magazine':'', trigger: 'hover click'}">
                                        {{ getDiscount(item) }}
                                    </h3>
                                </div>
                            </div>

                            <div v-if="item.type=='bundle' && item.status!='hidden'" class="bundle-items no-gutters mt-md-3 mb-3 ml-0 ml-md-n7 ml-lg-n8 ml-xl-n9 ml-xxl-n10 mr-n2 bg-light border px-2 pt-2">
                                <div v-for="(subitem, j) in item.games" :key="item.games[j].id" class="item">
                                    <edit-item :item="subitem" :index="j" :parent-id="item.id"></edit-item>
                                </div>
                                <span class="no-items text-center text-xs d-block">Activează modul sortare pentru a trage jocuri în pachet</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!['other', 'bundle'].includes(item.type)" class="row no-gutters mb-1">
                    <div class="col px-3">
                        <div class="input-group mb-0 text-gray align-left bg-light border px-2 p-0 p-md-2 px-md-3 d-block">
                            <div class="float-start">
                                <span class="text-xs text-md-s font-weight-bold mr-1">Notă:</span>
                            </div>
                            <div v-if="item.type=='boardgameexpansion'" class="float-start">
                                <span class="pr-2 text-xs text-md-s">
                                    Extensie pentru 
                                    <a class="mb-0 ml-0 font-weight-bold" :href="'https://boardgamegeek.com/boardgame/'+item.main_game.id" target="_blank">{{ item.main_game.name }} <i :class="'text-'+item.condition" class="fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></a>
                                </span>
                            </div>
                            <span class="d-block overflow-hidden">
                                <input v-model="item.notes" type="text" class="bg-light border-0 text-xs text-md-s w-100" :placeholder="item.type!='other' && item.type!='bundle'?'număr de partide jucate, sleeve-uri, cutie deteriorată, piese lipsă, etc.':(item.type=='other'?'avarii, piese lipsă, dimensiuni, etc.':'alte informații despre pachet')">
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="item.status=='hidden' || sort_mode || price_history[item.id]" class="p-2 py-3 py-md-2 h5 mb-0">
                <div class="d-flex justify-content-between font-weight-bold text-black-800 fs-mobile-6 font-header">
                    <span class="">{{ item.name }}</span>
                    <template v-if="!price_history[item.id]">
                        <span v-if="item.price && ['price', 'alphabetical', 'default'].includes(sorted_by)">{{ item.price }} RON</span>
                        <span v-if="item.shop && item.price && item.shop.stock && sorted_by=='discount'">{{ getDiscount(item) }}</span>
                        <span v-if="item.rating && sorted_by=='rating'">{{ item.rating }}</span>
                    </template>
                </div>
                <draggable v-if="item.type=='bundle' && item.status!='hidden'" :list="item.games" draggable=".item" @add="updatedBundle" @remove="updatedBundle" group="games" :disabled="!sort_mode" delay="300" delay-on-touch-only="true" ghost-class="ml-5" animation="150" class="drag-area nested-drag-area position-relative mt-3 bg-light border px-2 pt-2"> 
                    <span slot="footer" class="no-items text-center text-xs d-block">Trage jocuri aici pentru a le introduce în pachet</span>
                    <div v-for="(subitem, j) in item.games" :key="item.games[j].id" class="item">
                        <edit-item :item="subitem" :index="j"></edit-item>
                    </div>
                </draggable>
                <div v-if="price_history[item.id] && !sort_mode" class="row no-gutters">
                    <div class="col-12 position-static">
                        <div class="position-absolute top-0 end-0 p-2">
                            <div class="p-2 pb-0 mr-n1">
                                <span @click="hidePriceHistory(item.id)" class="cursor-pointer mr-1 align-middle"><span><i class="fa-solid fa-caret-down"></i></span></span>           
                                <a :href="'https://howtoplay.ro/oferte-boardgames/bgg-'+item.id" target="_blank" class="text-xs" :class="{ 'text-muted': !item.shop.stock }" data-toggle="tooltip" data-placement="top" :title="item.shop.name">
                                    <b v-if="item.shop.stock">NOU</b> 
                                    <span v-else>În trecut</span>
                                    de la <b>{{ item.shop.price }} RON</b> <span class="d-mobile-none ml-1">la <b>{{ item.shop.name }}</b></span> <span :class="'text-'+item.condition"><i class="ml-1 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
                                </a>
                            </div>
                        </div>
                        <LineChart :chart-data="price_history[item.id]" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="item.status=='reserved' && !sort_mode" class="reserved-text position-absolute text-uppercase page-title start-50 top-50 w-auto z-1">Rezervat</div>
    <div v-if="item.status=='reserved' && !sort_mode" class="mb-3 mb-md-4 pb-2 position-absolute bottom-0">
        <div class="col px-2 px-md-3 mb-1">
            <div class="input-group mb-0 text-gray align-left bg-warning-light border px-2 p-0 p-md-2 px-md-3 d-block">
                <div class="float-start">
                    <span class="text-xs text-md-s font-weight-bold mr-1">Notă privată:</span>
                </div>
                <span class="d-block overflow-hidden">
                    <input v-model="item.private_notes" type="text" class="bg-warning-light border-0 text-xs text-md-s w-100" placeholder="pentru cine am rezervat, status trimitere, etc.">
                </span>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import Vue from "vue";
    import HelperItemMixin from "../mixins/HelperItemMixin";
    import Popper from 'vue-popperjs';
    import VTooltip from 'v-tooltip'
    import draggable from 'vuedraggable'
    import LineChart from './LineChart.vue'

    Vue.use(VTooltip);

    export default {
        name: "EditItem",
        components: { 'popper': Popper, draggable, LineChart },
        mixins: [HelperItemMixin],
        props: ['item', 'index', 'parentId'],
        computed: { 
            sorted_by: function() { return this.parentId ? this.$parent.$parent.$parent.sorted_by : this.$parent.$parent.sorted_by; },
            sort_mode: function() { return this.parentId ? this.$parent.$parent.$parent.sort_mode : this.$parent.$parent.sort_mode; },
            is_thumbnail_uploading: function() { return this.parentId ? this.$parent.$parent.$parent.isThumbnailUploading(this.item) : this.$parent.$parent.isThumbnailUploading(this.item); },
            discount_label_class: function() {
                return 'background-'+this.checkDiscount(this.item)+' '+(this.item.type=='bundle'?'py-2 pl-2 pr-3 pr-md-4':'p-2');
            },
            price_history: function() { return this.parentId ? this.$parent.$parent.$parent.price_history : this.$parent.$parent.price_history; },
            loading_price_history: function() { return this.parentId ? this.$parent.$parent.$parent.loading_price_history : this.$parent.$parent.loading_price_history; },
            game_link: function() {
                if(!['other','bundle'].includes(this.item.type)) {
                    return 'https://boardgamegeek.com/boardgame/'+this.item.id;
                } 
                return '';
            }
        },
        data() { return { } },
        mounted() { },
        methods: {
            clickGame: function(item) { this.parentId ? this.$parent.$parent.$parent.clickGame(item): this.$parent.$parent.clickGame(item); },
            deleteGame: function(index) { this.parentId ? this.$parent.deleteSubItem(index) : this.$parent.$parent.deleteGame(index); },
            selectThumbnail: function(id) { this.parentId ? this.$parent.$parent.$parent.selectThumbnail(id, this.parentId) : this.$parent.$parent.selectThumbnail(id); },
            showPriceHistory: function(item) { this.parentId ? this.$parent.$parent.$parent.showPriceHistory(item): this.$parent.$parent.showPriceHistory(item); },
            hidePriceHistory: function(item) { this.parentId ? this.$parent.$parent.$parent.hidePriceHistory(item): this.$parent.$parent.hidePriceHistory(item); },


            updatedBundle: function(event) {
                var draggable = $(event.from);
                if(draggable.hasClass('nested-drag-area')) {
                    this.suggestBundlePrice(draggable.parents('.bundle').first().attr('bgg-id'));
                }
                draggable = $(event.to);
                if(draggable.hasClass('nested-drag-area')) {
                    this.suggestBundlePrice(draggable.parents('.bundle').first().attr('bgg-id'));
                }
            },
            suggestBundlePrice: function(bundle_id) {
                var _this = this.$parent.$parent;
                _this.games.forEach(function(item, i) {
                    if(item.id == bundle_id && (typeof item.price_set == "undefined" || !item.price_set)) {
                        item.price = _this.suggestPrice(item);
                    }
                });
            },
            deleteSubItem: function (index) {
                this.item.games.splice(index, 1);
            },
            updateCondition: function (event) {
                var _this = this;
                if(typeof _this.item.price_set == "undefined" || !_this.item.price_set) {
                    _this.item.condition = event.target.value;
                    if(_this.item.price) {
                        _this.item.price = _this.suggestPrice(_this.item);
                    }
                }
            },
            updatePrice: function (event) {
                var _this = this;
                _this.item.price = event.target.value;
                if(event.target.value) {
                    _this.item.price_set = true;
                } else {
                    _this.item.price_set = false;
                }
            }
        }
    };
</script>